/**
 * 自定义事件
 */

export default {
  install(Vue, options) {
    let eventList = Object.create(null)
    // 监听事件
    let onEventHandler = (type, handler) => {
      return (eventList[type.toLowerCase()] || (eventList[type.toLowerCase()] = [])).push(handler) - 1
    }

    // 移除监听事件
    let offEventHandler = (type, handler) => {
      let key = type.toLowerCase()
      if (eventList[key]) {
        eventList[key].splice(
          typeof handler === 'number' ? handler : eventList[key].indexOf(handler) >>> 0,
          1
        )
      }
    }

    // 触发事件
    let emitEventHandler = (type, evt) => {
      ;(eventList[type.toLowerCase()] || []).map(handler => handler(evt))
    }

    // 添加实例方法
    Vue.prototype.$eventEmitter = {
      on: onEventHandler,
      off: offEventHandler,
      emit: emitEventHandler
    }

    if (!options) {
      return
    }

    for (let i = 0; i < options.length; i++) {
      let eventName = options[i].replace(/^on/, '')

      // 监听事件别名
      Vue.prototype[`$${options[i]}`] = handler => onEventHandler(eventName, handler)

      // 移除监听事件别名
      Vue.prototype[`$${options[i].replace(/^on/, 'off')}`] = handler => offEventHandler(eventName, handler)

      // 添加全局函数，供客户端调用，触发事件
      window[options[i]] = () => emitEventHandler(eventName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugins/eventEmitter.js